<template>
    <div class="modal1Back">
            <div class="modal1">
            <img src="@/assets/icons/exit.svg" class="exit" @click="closeModal" />
            <div v-if="editFormLoading" class="modal1__sk home-sk-form" aria-busy="true" aria-label="Загрузка программы">
                <div v-for="n in 10" :key="n" class="sk sk--input" />
            </div>
            <template v-else>
            <div class="modal1__top">
                <p class="modal1__top__title">Добавить программу</p>
                <p class="modal1__top__sub">Заполните все поля для добавления новой программы</p>
                <div class="line"></div>
            </div>
            <p class="customTitle">Название программы и категоризация</p>
            <div class="modal1__inputs">
                <div class="customInput">
                    <label>Название программы</label>
                    <input type="text" v-model="formData.program_name.ru" placeholder="University of London" />
                </div>
                <div class="customInput">
                    <label>Стипендия</label>
                    <customSelect :list="stips" v-model="formData.scholarship_id" />
                </div>
                <div class="customInput">
                    <label>Степень</label>
                    <customSelect :list="steps" v-model="formData.study_degree_id" />
                </div>
                <div class="customInput">
                    <label>Категория</label>
                    <customSelect :list="categories" v-model="cat_id" @change="selectCat()" />
                </div>
                <div class="customInput">
                    <label>Подкатегория</label>
                    <customSelect :list="subCategories" v-model="formData.sub_category_id" />
                </div>
                <div class="customInput">
                    <label>Ссылка на сайт программы</label>
                    <input type="text" v-model="formData.link" placeholder="Ссылка" />
                </div>
                <div class="customInput">
                    <label>Название ВУЗа</label>
                    <customSelect :list="univers" v-model="formData.university_id" @change="selectUniver()" />
                </div>
                <div class="customInput">
                    <label>Страна</label>
                    <input placeholder="Страна" v-model="selectedCountry" disabled />
                </div>
                <div class="customInput">
                    <label>Штат</label>
                    <input placeholder="Штат" v-model="selectedState" disabled />
                </div>
                <div class="customInput">
                    <label>Город</label>
                    <input placeholder="Город" v-model="selectedCity" disabled />
                </div>
                <div class="customInput">
                    <label>Уровень</label>
                    <customSelect :list="ranks" v-model="formData.rank_id" />
                </div>
                <div class="customInput">
                    <label>GPA (Минимум)</label>
                    <input type="number" step="0.01" min="0" max="4" placeholder="3.00" v-model="formData.gpa_min" />
                </div>
                <div class="customInput">
                    <label>IELTS min</label>
                    <input type="number" step="0.5" min="0" max="9" placeholder="6.5" v-model="formData.ielts_min" />
                </div>
                <div class="customInput" v-if="formData.study_degree_id == 4">
                    <label>GRE/GMAT</label>
                    <customSelect :list="greGmatList" v-model="formData.gre_select_id" />
                </div>
                <div class="customInput"
                    v-if="formData.study_degree_id == 3 || formData.study_degree_id == 2 || formData.study_degree_id == null">
                    <label>SAT</label>
                    <customSelect :list="greGmatList" v-model="formData.sat_select_id" />
                </div>
                <div class="customInput">
                    <label>Deadline (Крайний срок)</label>
                    <input type="date" value="" v-model="formData.autumn_admission_end_date" />
                </div>
                <div class="customInput">
                    <label>Application fee</label>
                    <input type="text" v-model="formData.price" />
                </div>
                <div class="customInput">
                    <label>Продолжительность обучения</label>
                    <customSelect :list="durations" v-model="formData.duration_value" />
                </div>
                <div class="customInput">
                    <label>Депозит</label>
                    <customSelect :list="depositList" v-model="formData.is_deposit_required" />
                </div>
                <div class="customInput">
                    <label>Duolingo</label>
                    <customSelect :list="yesorno" v-model="formData.duolingo" />
                </div>
                <div class="customInput">
                    <label>Выбор студента</label>
                    <customSelect :list="yesorno" v-model="formData.is_student_choose" />
                </div>
                <div class="customInput">
                    <label>Ширина карты</label>
                    <input v-model="formData.latitude" />
                </div>
                <div class="customInput">
                    <label>Долгота карты</label>
                    <input v-model="formData.longitude" />
                </div>
                <div class="customInput">
                    <label>Ссылка на видео</label>
                    <input placeholder="Ссылка на видео" v-model="formData.video" />
                </div>
            </div>
            <p class="customTitle">Описание программы</p>
            <div class="modal1__textarea">
                <textarea v-model="formData.description.ru" placeholder="..."></textarea>
            </div>
            <div class="modal1__documents">
                <div class="customInput">
                    <label>Академические требования</label>
                    <textarea v-model="formData.details.ru"></textarea>
                </div>
                <div class="customInput">
                    <label>Перечень документов</label>
                    <textarea v-model="formData.docs.ru"></textarea>
                </div>
                <div class="customInput" style="width: 100%;">
                    <label>Другое</label>
                    <textarea v-model="formData.other.ru" style="height: 200px;"></textarea>
                </div>
            </div>
            <div class="modal1__photos">
                <div class="modal1__photos__image" v-for="(image, index) in formData.images" :key="index">
                <img :src="image.image" alt="Uploaded Image" />
                <button class="modal1__photos__delete" @click="removeImage(index)">
                    <img src="@/assets/icons/delete.svg"/>
                </button>
            </div>
             <div class="modal1__photos__image" v-for="(image, index) in newImages" :key="index">
                <img :src="image.preview" alt="Uploaded Image" />
                <button class="modal1__photos__delete" @click="removeNewImages(index)">
                    <img src="@/assets/icons/delete.svg"/>
                </button>
            </div>
            <label class="modal1__photos__in" for="addPhoto">
                <img src="@/assets/icons/plus.svg"/>
                <input 
                    type="file" 
                    multiple
                    id="addPhoto" 
                    style="display: none;" 
                    @change="handleFileChange" />
            </label>
            </div>
            <div class="modal1__buttons">
                <button @click="postProgram(), postNewImages()" class="modal1__buttons__save">Отправить</button>
                <button class="modal1__buttons__delete">Предпросмотр</button>
            </div>
            </template>
        </div>
    </div>
</template>
<script>
import customSelect from '../customSelect.vue';
import axios from "axios";
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
export default {
    data() {
        return {
            categories: [],
            editFormLoading: false,
            locations: [],
            subCategories: [],
            countries: [],
            cat_id: false,
            states: [],
            selectedCountry: '',
            selectedCountryId: null,
            selectedCityId: null,
            university_program_id: null,
            selectedCity: '',
            selectedState: '',
            newImages: [],
            steps: [],
            selectedCat: '',
            cities: [],
            stips: [],
            specials: [],
            yesorno: [
                {
                    id: 0,
                    title: 'Нет'
                },
                {
                    id: 1,
                    title: 'Да'
                },
            ],
            ranks: [
                {
                    id: 1,
                    title: 'Elite'
                },
                {
                    id: 2,
                    title: 'TOP'
                },
            ],
            partnerships: [
                {
                    id: 0,
                    title: 'Партнер'
                },
                {
                    id: 1,
                    title: 'нет'
                },
            ],
            choose: [
                {
                    id: 0,
                    title: 'Выбор'
                },
                {
                    id: 1,
                    title: 'нет'
                },
            ],
            greGmatList: [
                {
                    id: 1,
                    title: 'Требуется'
                },
                {
                    id: 2,
                    title: 'Не требуется'
                },
                {
                    id: 3,
                    title: 'Рекомендуется'
                },
            ],
            durations: [],
            univers: [],
            ieltsFilter: [
                { 
                    id: 1,
                    title: '5.0'
                },
                {
                    id: 2,
                    title: '5.5'
                },
                {
                    id: 3,
                    title: '6.0'
                },
                {
                    id: 4,
                    title: '6.5'
                },
                {
                    id: 5,
                    title: '7.0'
                },
                {
                    id: 6,
                    title: '7.5'
                }
            ],
            depositList: [
                {
                    id: 0,
                    title: 'Требуется'
                },
                {
                    id: 1,
                    title: 'Не требуется'
                }
            ],
            formData: {
                program_name: {
                    en: "",
                    ru: "",
                    kz: ""
                },
                university_program_id: this.itemId,
                sub_category_id: null,
                scholarship_id: null,
                study_degree_id: null,
                university_id: null,
                autumn_admission_end_date: '',
                price: '',
                duration_value: null,
                link: '',
                rank_id: null,
                gpa_min: null,
                ielts_min: null,
                duolingo: null,
                images: [],
                is_deposit_required: 1,
                longitude: '',
                latitude: '',
                gre_select_id: null,
                sat_select_id: null,
                is_student_choose: null,
                video: '',
                description: {
                    ru: "",
                    kz: "kz",
                    en: "en"
                },
                other: {
                    ru: "",
                    kz: "kz",
                    en: "en"
                },
                details: {
                    ru: "",
                    kz: "kz",
                    en: "en"
                },
                docs: {
                    ru: "",
                    kz: "kz",
                    en: "en"
                },
                status: this.itemId ? 1 : 0,
            }
        }
    },
    props: [
        'itemId'
    ],
    components: {
        customSelect
    },
    methods: {
        handleFileChange(event){
        const files = event.target.files;
        if (files.length > 0) {
            for (let i = 0; i < files.length; i++) {
            const file = files[i];
            const reader = new FileReader();
            reader.onload = (e) => {
                this.newImages.push({
                file: file,
                preview: e.target.result
                });
            };
            reader.readAsDataURL(file);
            }
        }
        },
        removeImage(index){
            this.formData.images.splice(index, 1)
        },
        removeNewImages(index){
            this.newImages.splice(index, 1)
        },
        selectCat() {
            this.subCategories = this.categories.filter(item => item.id == this.cat_id)[0].subCategories
        },
        selectUniver() {
            this.selectedUniver = this.univers.filter(item => item.id == this.formData.university_id)
            this.selectedCity = this.cities.filter(item => item.id == this.selectedUniver[0].city_id)[0]?.title
            this.selectedCountry = this.countries.filter(item => item.id == this.selectedUniver[0].country_id)[0]?.title
            this.selectedCityId = this.cities.filter(item => item.id == this.selectedUniver[0].city_id)[0]?.state_id
            this.selectedCountryId = this.countries.filter(item => item.id == this.selectedUniver[0].country_id)[0]?.id
            axios.get(`/platform/getLocation?university_id=${this.formData.university_id}`, {
            })
                .then(res => {
                    this.locations = res.data.data
                    console.log('gala');
                    
                })
                .catch(err => {
                })

            this.selectedState = this.states.filter(item => item.id == this.selectedCityId)[0]?.title
        },
        async getPage() {
            await axios.get(`/platform/scholarships`, {
            })
                .then(res => {
                    this.stips = res.data.data
                })
                .catch(err => {
                })
            await axios.get(`platform/universities`, {
            })
                .then(res => {
                    this.univers = res.data.data
                })
                .catch(err => {
                })
            await axios.get(`/V1/programs`, {
            })
                .then(res => {
                    this.specials = res.data.data
                })
                .catch(err => {
                })
            await axios.get(`/platform/filter-values?type=5`)
                .then(res => {
                    this.durations = res.data.data.map(item => ({
                        ...item,
                        title: item.value // Заменяем value на title
                    }));
                })
                .catch(err => {
                    console.error(err);
                });
            await axios.get(`/platform/countries`, {
            })
                .then(res => {
                    this.countries = res.data.data
                })
                .catch(err => {
                })
            await axios.get(`/platform/cities`, {
            })
                .then(res => {
                    this.cities = res.data.data
                })
                .catch(err => {
                })
            await axios.get(`/platform/study-degrees`, {
            })
                .then(res => {
                    this.steps = res.data.data
                })
                .catch(err => {
                })
            await axios.get(`/platform/categories`, {
            })
                .then(res => {
                    this.categories = res.data.data
                })
                .catch(err => {
                })
            if (this.itemId != null) {
                this.editFormLoading = true;
                await axios.get(`/V1/editUniversityPrograms?university_program_id=${this.itemId}`, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                    }
                })
                    .then(res => {
                        this.formData = res.data.universityProgram
                        this.cat_id = res.data.universityProgram.subcategory.category_id
                        this.selectCat()
                        this.formData.sub_category_id = res.data.universityProgram.subcategory_id
                        this.formData.images = res.data.universityProgram.images
                        this.selectUniver()
                        this.formData.autumn_admission_end_date = this.formatDate(res.data.universityProgram.autumn_admission_end_date)
                        axios.get(`/platform/states?country_id=${this.selectedCountryId}`, {
                        })
                            .then(res => {
                                this.states = res.data.data
                            })
                            .catch(err => {
                            })
                    })
                    .catch(err => {
                    })
                    .finally(() => {
                        this.editFormLoading = false;
                    })
            }

        },
        closeModal() {
            this.$emit('closeModal')
        },
        formatDate(dateString) {
            const date = new Date(dateString);
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
        async postProgram() {
             // Копируем formData, чтобы не мутировать оригинал
            const payload = { ...this.formData };
            // Преобразуем is_deposit_required: 0 → true, 1 → false
            payload.is_deposit_required = this.formData.is_deposit_required === 0;
            try {
                const response = await axios.post(`/V1/${this.itemId ? 'update' : 'create'}/universityPrograms`, payload, {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                    }
                });
                if(response.status === 201) {
                    if(!this.itemId){
                        this.university_program_id = response.data.id;
                        this.$emit('addProgram', this.university_program_id);
                    }
                    toast.success('Успешно создано!')
                    this.$emit('closeModal');
                } else {
                    console.error('Error posting program:', response);
                }
            } catch (error) {
                console.error('Error while posting program:', error);
            }
        },
        async postNewImages(){
            if(this.newImages){
                const formData = new FormData();
            this.newImages.forEach((imgObj, index) => {
                formData.append(`image[${index}]`, imgObj.file); // <-- File, не строка
            });
            formData.append('university_program_id', this.itemId); // используй props
            axios.post(`/V1/universityProgramsImages`, formData, {
                headers: {
                Authorization: `Bearer ${localStorage.getItem("access_token")}`,
                },
            })
            .then((response) => {
                if (response.status === 200) {
                }
            })
            .catch((error) => {
                console.error(error);
            });
            }
        }
    },
    async created() {
        this.getPage();
    }
}
</script>
<style lang="scss" scoped>
.line {
    border: 1px solid #0000001A;
    width: 100%;
}

.modal1Back {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    display: flex;
    justify-content: center;
    z-index: 999;
    align-items: center;
    background-color: #0000007a;
}

.modal1 {
    width: 64%;
    .exit {
        position: absolute;
        top: min(max(14px, calc(0.875rem + ((1vw - 7.68px) * 0.5208))), 20px);
        cursor: pointer;
        right: min(max(14px, calc(0.875rem + ((1vw - 7.68px) * 0.5208))), 20px);
        filter: brightness(0) saturate(100%);
        width: min(max(14px, calc(0.875rem + ((1vw - 7.68px) * 0.5208))), 20px);
        height: min(max(14px, calc(0.875rem + ((1vw - 7.68px) * 0.5208))), 20px);
    }
    &__photos{
        display: flex;
        flex-wrap: wrap;
        gap: 2%;
        &__delete{
            position: absolute;
            top: 5px;
            right: 5px;
            background-color: white;
            border: none;
            cursor: pointer;
            border-radius: 10px;
            img{
                width: 15px;
                height: 15px;
                object-fit: fill !important;
                border-radius: 0 !important;
            }
        }
        &__image{
            width: 15%;
            aspect-ratio: 1;
            background-color: #F8F8F8;
            display: flex;
            box-shadow: 0px 0px 8px 4px #0000000D inset;
            border: 1px solid #0000001A;
            border-radius: 10px;
            position: relative;
            img{
                width: 100%;
                aspect-ratio: 1;
                object-fit: cover;
                border-radius: 10px;
            }
        }
        &__in{
            width: 15%;
            aspect-ratio: 1;
            background-color: #F8F8F8;
            display: flex;
            box-shadow: 0px 0px 8px 4px #0000000D inset;
            border: 1px solid #0000001A;
            border-radius: 10px;
            cursor: pointer;
            img{
                width: 50% !important;
                height: 50%;
                margin: auto;
            }
        }
    }
    &__top {
        display: flex;
        flex-direction: column;
        gap: 10px;
        align-items: center;
        width: 100%;

        &__title {
            color: #11415D;
            font-size: min(max(18px, calc(1.125rem + ((1vw - 7.68px) * 1.2153))), 32px);
            font-weight: 600;
        }

        &__sub {
            color: #0000008A;
        }
    }

    &__inputs {
        display: flex;
        flex-wrap: wrap;
        gap: 2%;
        row-gap: min(max(15px, calc(0.9375rem + ((1vw - 7.68px) * 0.8681))), 25px);
    }

    &__files {
        display: flex;
        gap: 1%;
        align-items: center;

        &__in {
            width: 10%;

            img {
                width: 100%;
                aspect-ratio: 1;
                object-fit: cover;
                border-radius: 10px;
                cursor: pointer;
            }
        }

        &__plus {
            width: 10%;
            border-radius: 10px;
            cursor: pointer;
            color: #0000008A;
            aspect-ratio: 1;
            display: flex;
            flex-direction: column;
            gap: 10px;
            background-color: #F0F2F5;
            align-items: center;
            justify-content: center;

            img {
                width: min(max(18px, calc(1.125rem + ((1vw - 7.68px) * 1.0417))), 30px);
                height: min(max(18px, calc(1.125rem + ((1vw - 7.68px) * 1.0417))), 30px);
            }
        }
    }

    &__documents {
        display: flex;
        flex-wrap: wrap;
        row-gap: 30px;
        justify-content: space-between;

        .customInput {
            width: 48%;
        }
    }

    &__textarea {
        width: 100%;

        textarea {
            width: 100%;
            height: 250px;
            resize: none;
            border: 1px solid #0000001A;
            border-radius: 10px;
            padding: min(max(10px, calc(0.625rem + ((1vw - 7.68px) * 0.434))), 15px)min(max(15px, calc(0.9375rem + ((1vw - 7.68px) * 0.8681))), 25px);
        }
    }

    &__buttons {
        display: flex;
        gap: 2%;

        button {
            width: 30%;
            border: none;
            height: min(max(25px, calc(1.5625rem + ((1vw - 7.68px) * 2.1701))), 50px);
            border-radius: 10px;
        }

        &__save {
            color: white;
            font-size: min(max(14px, calc(0.875rem + ((1vw - 7.68px) * 0.5208))), 20px);
            background-color: #11415D;
            border: 1px solid #11415D;
            transition: all 0.5s ease;

            &:hover {
                color: white;
                background-color: #2076a7;
            }
        }

        &__delete {
            background-color: inherit;
            border: 1px solid #0000001A !important;
            color: #0000008A;
            font-size: min(max(14px, calc(0.875rem + ((1vw - 7.68px) * 0.5208))), 20px);
            transition: all 0.5s ease;

            &:hover {
                color: white;
                background-color: #11415D;
                border: 1px solid #11415D;
            }
        }
    }
}

.customTitle {
    font-size: min(max(16px, calc(1rem + ((1vw - 7.68px) * 0.6944))), 24px);
    font-weight: 600;
}

.customInput {
    position: relative;
    display: inline-block;
    width: 32%;
    cursor: pointer !important;

    label {
        position: absolute;
        top: -8px;
        left: min(max(15px, calc(0.9375rem + ((1vw - 7.68px) * 0.8681))), 25px);
        background-color: #ffffff;
        /* Цвет фона, чтобы совпадал с фоном */
        padding: 0 10px;
        font-size: min(max(9px, calc(0.5625rem + ((1vw - 7.68px) * 0.434))), 14px);
        color: #c0c0c0;
        z-index: 98;
    }

    input,
    select {
        width: 100%;
        padding: 0px min(max(15px, calc(0.9375rem + ((1vw - 7.68px) * 0.8681))), 25px);
        height: min(max(25px, calc(1.5625rem + ((1vw - 7.68px) * 2.1701))), 50px);
        border: 1px solid #e0e0e0;
        /* Цвет рамки */
        border-radius: 8px;
        font-size: min(max(14px, calc(0.875rem + ((1vw - 7.68px) * 0.5208))), 20px);
        background-color: inherit;
        color: #000;
        /* Цвет текста */
        outline: none;
    }

    div {
        width: 100%;
        resize: none;
        border-radius: 10px;
    }

    textarea {
        width: 100%;
        border: 1px solid #00000010;
        height: min(max(150px, calc(9.375rem + ((1vw - 7.68px) * 13.0208))), 300px);
        resize: none;
        border-radius: 10px;
        padding: min(max(10px, calc(0.625rem + ((1vw - 7.68px) * 0.434))), 15px)min(max(15px, calc(0.9375rem + ((1vw - 7.68px) * 0.8681))), 25px);
    }

    img {
        position: absolute;
        left: min(max(10px, calc(0.625rem + ((1vw - 7.68px) * 0.434))), 15px);
        top: 50%;
        width: 5%;
        height: 10px;
        transform: translate(-50%, -50%);
        filter: brightness(0) saturate(100%) invert(46%) sepia(75%) saturate(3165%) hue-rotate(213deg) brightness(100%) contrast(103%);
    }
}
</style>